import { render } from "./OnScreenKeyboard.vue?vue&type=template&id=46a1d02d&ts=true"
import script from "./OnScreenKeyboard.vue?vue&type=script&lang=ts"
export * from "./OnScreenKeyboard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__